export const environment = {
    production: true
};

// local storage keys of persistent values
export const STORE_NAME = 'zkminv';
export const USER_LANGUAGE_KEY = 'admin-language';
export const STORAGE_REFRESH_NONCE_KEY = 'refresh_nonce';

// timeout and retry values
export const BROWSER_ENGINE_WAIT_RETRIES = 20;
export const BROWSER_ENGINE_WAIT_TIME = 20; // ms
export const APP_ENGINE_WAIT_RETRIES = 20;
export const APP_ENGINE_WAIT_TIME = 10; // ms
export const HTTP_TIMEOUT = 8000; // ms
